const isAssetLocal = (url) => {
    // todo: is it necessary?
    const str = url.toString();

    return str.startsWith('https://storage.googleapis.com/') && str.includes('.weadapt.digital/');
};

// todo: check url type
export const crossOrigin = (url) => (isAssetLocal(url) ? {} : ({ crossOrigin: 'anonymous' } as const));
